export default __webpack_public_path__ + "bb7a8d0ffa3ece5e47584196715362d1.svg";